import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { Line } from "react-chartjs-2";
import { Chart, LineElement, PointElement, CategoryScale, LinearScale } from "chart.js";

Chart.register(LineElement, PointElement, CategoryScale, LinearScale);

export default function CreditScoreTrend({ data }) {
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: "Credit Score",
        data: data.values,
        borderColor: "#4caf50",
        backgroundColor: "transparent",
        tension: 0.3,
        pointRadius: 3,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    scales: {
      y: {
        min: 700,
        max: 800,
        ticks: { stepSize: 10 },
        grid: { color: "rgba(255,255,255,0.1)" },
      },
      x: {
        grid: { color: "rgba(255,255,255,0.05)" },
      },
    },
    plugins: {
      legend: { display: false },
    },
  };

  return (
    <Card
      sx={{
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.default",
      }}
    >
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" mb={1}>
          Credit Score Trend
        </Typography>
        <Line data={chartData} options={chartOptions} />
      </CardContent>
    </Card>
  );
}
